import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blockers: {},
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    registerBlocker: (state, { payload }) => {
      state.blockers[payload.id] = payload.shouldBlock;
    },
    unregisterBlocker: (state, { payload }) => {
      delete state.blockers[payload.id];
    },
    clearAllBlockers: (state) => {
      state.blockers = {};
    },
  },
});

export const { registerBlocker, unregisterBlocker, clearAllBlockers } =
  navigationSlice.actions;

export const selectShouldBlockNavigation = (state) =>
  Object.values(state.navigation.blockers).some(Boolean);

export default navigationSlice.reducer;
